/**
 * Hook para importación/exportación de archivos iCal
 * @module hooks/useICalExport
 */

import { useMutation } from '@tanstack/react-query';
import { icalService } from '@/services/icalService';
import type {
  ICalExportParams,
  ICalImportParams,
} from '@/types/calendar.types';

/**
 * Hook para exportar calendario a iCal
 */
export const useICalExport = () => {
  return useMutation({
    mutationFn: async (params?: ICalExportParams) => {
      await icalService.downloadICalFile(params);
    },
  });
};

/**
 * Hook para importar calendario desde iCal
 */
export const useICalImport = () => {
  return useMutation({
    mutationFn: async ({
      file,
      params,
    }: {
      file: File;
      params?: ICalImportParams;
    }) => {
      return await icalService.import(file, params);
    },
  });
};
